import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadImgComponent } from './components/upload-img/upload-img.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '../input/input.module';
import { ButtonModule } from '../button/button.module';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { SelectModule } from '../select/select.module';
import { DialogModule } from '../../shared/components/dialog/dialog.module';
import { CloseBtnModule } from '../close-btn/close-btn.module';
import { PopoverLoaderModule } from '../popover-loader/popover-loader.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [UploadImgComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    ButtonModule,
    AngularCropperjsModule,
    SelectModule,
    DialogModule,
    CloseBtnModule,
    MatButtonModule,
    MatIconModule,
    PopoverLoaderModule
  ],
  exports: [UploadImgComponent]
})
export class UploadImgModule { }
